import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import styles from './ConfirmationModal.module.css';

const ConfirmationModal = ({ show, onHide, onConfirm, titleKey, bodyKey, customDeleteBtnName }) => {
    const { t } = useTranslation('common');

    return (
        <Modal show={show} onHide={onHide} dialogClassName={styles['rtl-modal']} centered >
            <Modal.Header>
                <Modal.Title>{t(titleKey)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles['modal-body']}>{t(bodyKey)}</Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={onConfirm}>{customDeleteBtnName || t('Delete Contact')}</Button>
                <Button variant="secondary" onClick={onHide}>{t('Cancel')}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;